var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89463 8.86129L0.16792 4.92195C-0.0559734 4.68528 -0.0559734 4.30155 0.16792 4.06486L0.978726 3.20777C1.20262 2.97107 1.56566 2.97107 1.78955 3.20777L4.30004 5.86147L9.67723 0.177501C9.90113 -0.0591671 10.2642 -0.0591671 10.4881 0.177501L11.2989 1.03459C11.5228 1.27126 11.5228 1.65499 11.2989 1.89168L4.70546 8.86132C4.48154 9.09799 4.11852 9.09799 3.89463 8.86129Z",
    fill: "#0057B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckblue);
export default __webpack_public_path__ + "static/media/checkblue.c86de1200d2179e365778a8da0f82e7d.svg";
export { ForwardRef as ReactComponent };